import React from "react";
import { Box, Flex } from "rebass/styled-components";
import useTranslation from "next-translate/useTranslation";
import Heading from "../common/Heading";
import Rating from "../common/Rating";

import ReviewCard from "../sitterprofile/ReviewCard";
import { GetDogProfileQueryResult } from "../../generated/graphql";

interface Props {
  dog: GetDogProfileQueryResult["data"]["dog"];
}

const Review = ({ dog }: Props) => {
  const { t } = useTranslation("dogprofile");
  return dog.reviews.length > 0 ? (
    <Flex
      sx={{
        flexDirection: "column",
        mt: 3
      }}
    >
      <Flex
        px={[2, 2, 0]}
        sx={{
          justifyContent: "space-between",
          alignItems: "flex-end"
        }}
      >
        <Heading>{t("reviews")}</Heading>
        <Box fontSize={6}>
          <Rating score={5} />
        </Box>
      </Flex>
      <Flex
        mt={3}
        sx={{
          flexDirection: "column"
        }}
      >
        {dog.reviews.map(review => {
          const [id, title] = review.author.slug.split(/-(.+)/);

          return (
            <ReviewCard
              review={review}
              key={review.id}
              link={{
                id: id,
                title: title
              }}
            />
          );
        })}
      </Flex>
    </Flex>
  ) : null;
};

export default Review;
